export const environment = {
  production: false,
  apiBaseUrl: "https://dev.kodextech.com/WorkInsight-Backend-PHP/api",
  apiBaseUrlAdmin: "https://dev.kodextech.com/WorkInsight-Backend-PHP",
  imageBaseURL: "https://dev.kodextech.com/WorkInsight-Backend-PHP/public/img",
  oneSignalKEY: "0b67c768-a345-4b1a-86ec-5d6b69484be9",
  GoogleMapKey: "AIzaSyAsPHLGVPd41yWV4r3-1UsO1QPt3Y-KR7E",
  consolePassword: "KDX@!#CnsL123",
};
